var _line, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarvinDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 371,
    viewBox: "0 0 29 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: -4.37114e-8,
    x2: 15,
    y2: 160,
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 211,
    x2: 15,
    y2: 371,
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5508 185.842C14.5508 186.942 14.4108 187.945 14.1309 188.85C13.8574 189.748 13.444 190.523 12.8906 191.174C12.3372 191.818 11.6439 192.316 10.8105 192.668C9.97721 193.02 9.00065 193.195 7.88086 193.195C6.74154 193.195 5.75195 193.02 4.91211 192.668C4.07878 192.316 3.38542 191.815 2.83203 191.164C2.28516 190.513 1.875 189.735 1.60156 188.83C1.32812 187.925 1.19141 186.923 1.19141 185.822C1.19141 184.351 1.43229 183.068 1.91406 181.975C2.40234 180.874 3.14128 180.021 4.13086 179.416C5.12695 178.804 6.38346 178.498 7.90039 178.498C9.38477 178.498 10.6185 178.801 11.6016 179.406C12.5846 180.012 13.3203 180.865 13.8086 181.965C14.3034 183.059 14.5508 184.351 14.5508 185.842ZM3.65234 185.842C3.65234 186.942 3.80208 187.896 4.10156 188.703C4.40104 189.504 4.86003 190.122 5.47852 190.559C6.10352 190.988 6.9043 191.203 7.88086 191.203C8.86393 191.203 9.66471 190.988 10.2832 190.559C10.9017 190.122 11.3574 189.504 11.6504 188.703C11.9434 187.896 12.0898 186.942 12.0898 185.842C12.0898 184.169 11.7546 182.86 11.084 181.916C10.4199 180.965 9.35872 180.49 7.90039 180.49C6.92383 180.49 6.11979 180.705 5.48828 181.135C4.86328 181.564 4.40104 182.18 4.10156 182.98C3.80208 183.775 3.65234 184.729 3.65234 185.842ZM21.6309 178.723C22.8613 178.723 23.877 178.872 24.6777 179.172C25.485 179.471 26.084 179.927 26.4746 180.539C26.8717 181.151 27.0703 181.929 27.0703 182.873C27.0703 183.576 26.9401 184.175 26.6797 184.67C26.4193 185.165 26.0775 185.575 25.6543 185.9C25.2311 186.226 24.7786 186.486 24.2969 186.682L28.3496 193H25.7031L22.2559 187.277H19.9609V193H17.6172V178.723H21.6309ZM21.4746 180.676H19.9609V185.344H21.582C22.6693 185.344 23.457 185.142 23.9453 184.738C24.4401 184.335 24.6875 183.739 24.6875 182.951C24.6875 182.124 24.4238 181.538 23.8965 181.193C23.3757 180.848 22.5684 180.676 21.4746 180.676Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarvinDivider);
export default __webpack_public_path__ + "static/media/marvinDivider.8da369ef9b4ef5ecd6543be68426a411.svg";
export { ForwardRef as ReactComponent };